import { useEffect, useState } from "react";
import InputRange from "./InputRange";
import { useStorePads } from "../store";
import useMidiMapping from "../hooks/useMidiMapping";

export function Footer() {
    const [
        volume,
        setVolume,
        highpassFrequency,
        setHighpassFrequency,
        lowpassFrequency,
        setLowpassFrequency,
    ] = useStorePads((state) => [
        state.volume,
        state.setVolume,
        state.highpassFrequency,
        state.setHighpassFrequency,
        state.lowpassFrequency,
        state.setLowpassFrequency,
    ])
    const { initMidi, subscribeMidiMessages, getNoteName, isMidiSupported } = useMidiMapping()
    const [lastMidiMessage, setLastMidiMessage] = useState(null)

    useEffect(() => {
        initMidi()
    }, [initMidi])

    useEffect(() => {
        const unsubscribe = subscribeMidiMessages((message) => {
            setLastMidiMessage(message)
        })

        return () => unsubscribe()
    }, [subscribeMidiMessages])

    const midiLoggerText = (() => {
        if (!isMidiSupported) return 'MIDI no disponible en este navegador'
        if (!lastMidiMessage) return 'Esperando MIDI...'

        if (lastMidiMessage.type === 'note') {
            return `NOTE ${getNoteName(lastMidiMessage.number)} | value ${lastMidiMessage.value}`
        }

        if (lastMidiMessage.type === 'cc') {
            return `CC ${lastMidiMessage.number} | value ${lastMidiMessage.value}`
        }

        return 'Esperando MIDI...'
    })()

    return (
        <footer className="w-full py-6 px-4 sm:px-6 bg-neutral-900 shadow-md flex flex-col gap-3 sm:flex-row items-center justify-between">
            <div className="w-full flex flex-col gap-3 justify-between sm:flex-row sm:items-center">
                <InputRange
                    label="Vol"
                    min={0}
                    max={1}
                    value={volume}
                    templateValue={volume * 100}
                    className="w-full"
                    onChange={(e) => setVolume(parseFloat(e.target.value))}
                />
                <InputRange
                    label="HP"
                    min={20}
                    max={5000}
                    step={1}
                    value={highpassFrequency}
                    templateValue={highpassFrequency}
                    unit="Hz"
                    className="w-full"
                    onChange={(e) => setHighpassFrequency(parseInt(e.target.value, 10))}
                />
                <InputRange
                    label="LP"
                    min={500}
                    max={20000}
                    step={1}
                    value={lowpassFrequency}
                    templateValue={lowpassFrequency}
                    unit="Hz"
                    className="w-full"
                    onChange={(e) => setLowpassFrequency(parseInt(e.target.value, 10))}
                />
            </div>
            <div className="min-w-fit sm:w-auto sm:min-w-[220px] rounded border border-neutral-700 bg-neutral-950 px-3 py-2 text-xs text-neutral-300">
                <span className="block text-[10px] uppercase tracking-wider text-neutral-500">MIDI Logger</span>
                <span className="block truncate">{midiLoggerText}</span>
            </div>
        </footer>
    )
}
